import styled, { css } from 'styled-components';
import device from 'utils/device';
import { Atom } from 'AppReact';

const template = styled.label`
  ${({ theme, displayState }) => css`
      height: 43px;
      width: ${displayState?.width ?? "100%"};
      display: flex;
      align-items: center;
      justify-content: center;
      background: #FFFFFF;
      border: 1px solid #EEEEEE;
      box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.08);
      border-radius: 8px;
      cursor: pointer;
      color: ${theme?.colour?.secondary};
      font-size: 14px;
      font-weight: 400;
      line-height: 20px;
      letter-spacing: 0.1px;
      text-decoration-line: underline;
      &:hover {
        border: 1px solid ${theme?.colour?.primary};
        color: ${displayState?.color ? displayState.color : null};
      }
      @media ${device.tablet} {
        padding-left: 45px;
        width: ${displayState.width ?? "250px"};
        justify-content: unset;
      }
    `
  }
`;

export default Atom({ type: 'uploadMultiple', dataType: '', template: template })